import { Box, Container, Alert, AlertIcon, Center, Spinner } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { useSolicitarTroca } from './hooks/useSolicitarTroca'
import { SearchForm } from './components/SearchForm'
import { ProductSelector } from './components/ProductSelector'
import { PhotoUpload } from './components/PhotoUpload'
import { CameraView } from './components/CameraView'
import { SubmitButton } from './components/SubmitButton'
import { ExtraFields } from './components/ExtraFields'

export function SolicitarTroca() {
  const {
    numNota,
    setNumNota,
    selectedProduto,
    pedidoData,
    isLoading,
    isError,
    error,
    isFetching,
    isSearching,
    photos,
    showCamera,
    currentPhotoIndex,
    videoRef,
    canvasRef,
    submitting,
    observacao,
    setObservacao,
    quantidade,
    setQuantidade,
    handleSearch,
    handleProdutoChange,
    openCamera,
    capturePhoto,
    closeCamera,
    removePhoto,
    handleSubmit,
    allPhotosTaken,
    atLeastOnePhotoTaken,
  } = useSolicitarTroca()

  const selectedItem = pedidoData?.itens?.find((item) => item.sequencia.toString() === selectedProduto)

  return (
    <Box bgColor="#313E44" minH="100vh">
      <HeadingPages name={'SOLICITAR TROCA'} bgColor={'#f5a623'} />

      <Container maxW="container.xl" py={6}>
        <SearchForm numNota={numNota} setNumNota={setNumNota} isLoading={isLoading || isFetching || isSearching} handleSearch={handleSearch} />

        {isError && (
          <Alert status="error" mb={6} borderRadius="md">
            <AlertIcon />
            {error?.response?.data?.message || 'Erro ao buscar os dados do pedido'}
          </Alert>
        )}

        {(isLoading || isFetching) && (
          <Center h="200px">
            <Spinner size="xl" color="#37F091" />
          </Center>
        )}

        {pedidoData && !isLoading && !isFetching && (
          <>
            <ProductSelector pedidoData={pedidoData} selectedProduto={selectedProduto} handleProdutoChange={handleProdutoChange} />

            {selectedProduto && (
              <ExtraFields
                observacao={observacao}
                setObservacao={setObservacao}
                quantidade={quantidade}
                setQuantidade={setQuantidade}
                selectedItem={selectedItem}
              />
            )}

            <PhotoUpload photos={photos} openCamera={openCamera} removePhoto={removePhoto} allPhotosTaken={allPhotosTaken} />

            <SubmitButton
              onSubmit={handleSubmit}
              isSubmitting={submitting}
              isDisabled={!selectedProduto || !atLeastOnePhotoTaken() || !observacao.trim() || !quantidade || quantidade <= 0}
              allPhotosTaken={allPhotosTaken}
              selectedProduto={selectedProduto}
              observacao={observacao}
              quantidade={quantidade}
            />
          </>
        )}
      </Container>

      <CameraView
        isOpen={showCamera}
        onClose={closeCamera}
        videoRef={videoRef}
        canvasRef={canvasRef}
        onCapture={capturePhoto}
        currentIndex={currentPhotoIndex}
      />
    </Box>
  )
}
